import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { getServiceRoute } from "@/data/services";

export default function ProductCard({ service, ctaLabel }) {
  const { t, to, lang } = useLang();
  const c = service[lang];
  const route = getServiceRoute(service);
  return (
    <Link
      to={to(route)}
      data-testid={`product-card-${service.slug}`}
      className="nek-card group relative flex flex-col p-6 hover:-translate-y-1 hover:border-nek-blue hover:shadow-lift"
    >
      <span className="h-0.5 w-8 rounded-full bg-nek-teal transition-all duration-300 group-hover:w-14" aria-hidden="true" />
      <h3 className="mt-5 text-lg font-heading font-bold text-nek-navy">{c.name}</h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-nek-gray">{c.benefit}</p>
      <span className="link-arrow mt-5 text-sm">
        {ctaLabel || t.cta.discover}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
